var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.slim)?_c('div',{staticClass:"indicator-inline"},[_c('div',{class:_vm.dotClasses}),_c('p',[_vm._v(_vm._s(_vm.label))])]):_c('BTag',{attrs:{"rounded":"","size":"is-large"}},[_c('div',{staticClass:"indicator"},[_c('div',{class:_vm.dotClasses}),_c('div',[_vm._v("Status: "+_vm._s(_vm.label))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }